import * as React from 'react';
import classNames from 'classnames';
import { NvMarkdown } from '@invitae/ids-react';
import styles from './FootnoteSection.module.esm.js';

var FootnoteSection = function (_a) {
    var fields = _a.fields, id = _a.id;
    return (React.createElement("footer", { className: classNames('nv-container', 'nv-fine-print-2', styles.root), id: id },
        React.createElement(NvMarkdown, { options: { forceWrapper: false } }, fields.body)));
};

export { FootnoteSection as default };
//# sourceMappingURL=FootnoteSection.esm.js.map
